import { Flex, Grid, Select, SelectProps } from "antd";
import { CenterPopup } from "antd-mobile";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SkiOutlined from "../../assets/images/icons/SkiOutlined";
import { SkillResponse } from "../../hooks/Skills/data";
import { useGetSkills } from "../../hooks/Skills/skills.hooks";
import { P1, P3 } from "../NormalFonts";
import { SkillSelectorProps } from "./data";
import styles from "./styles.module.scss";
import "./styles.scss";

const iconEnum: Record<string, string> = {
  SKI: `/images/contents/${process.env.REACT_APP_PROD_NAME_DEV}/common/skiing.png`,
  SB: `/images/contents/${process.env.REACT_APP_PROD_NAME_DEV}/common/snowboard.png`,
};

const SkillSelector: React.FC<SkillSelectorProps> = ({ form, skillCode }) => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { data: skillList } = useGetSkills({ enabled: !skillCode });
  const [skillOptions, setSkillOptions] = useState<SelectProps["options"]>([]);
  const [openDropdown, setOpenDropdown] = useState<boolean>(false);
  const [openPopup, setOpenPopup] = useState<boolean>(false);

  const [selectedValue, setSelectedValue] = useState<
    string | number | null | undefined
  >(undefined);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (screens.sm) return;
    e.stopPropagation();
    setOpenPopup((prev) => !prev);
  };

  const handleDropdownVisibleChange = (visible: boolean) => {
    if (screens.sm) {
      setOpenDropdown(visible);
    } else {
      setOpenDropdown(false);
    }
  };
  const handleSkillChange = (val: string | number | undefined | null) => {
    onSkillChange(val);
    setSelectedValue(val);
    setOpenPopup(false);
  };

  const renderSkillDropdownContent = () => {
    if (!skillOptions) return;
    return (
      <div className={styles.popupItem}>
        {skillOptions.map((opt, index: number) => {
          return (
            <div
              key={`skillselector_${index}`}
              className={`${styles.item}`}
              onClick={() => handleSkillChange(opt.value)}
            >
              {opt.label}
            </div>
          );
        })}
        <P3 style={{ margin: "4px 0 4px 20px" }} color="var(--info)">
          {t("age.skill.recomendation")}
        </P3>
      </div>
    );
  };

  const onSkillChange = (val: string | number | null | undefined) => {
    form.setFieldsValue({ skill_type: val });
  };

  useEffect(() => {
    let _skill: SelectProps["options"] = [];
    const renderSkillLabel = (code: string) => {
      return (
        <Flex vertical gap={2}>
          <Flex gap={4}>
            <img
              src={iconEnum[code]}
              alt="skill"
              width={screens.md ? 22 : 16}
              height={screens.md ? 22 : 16}
            />
            <P1
              color="var(--Neutral-dark-70)"
              style={{ fontSize: screens.md ? 16 : 12 }}
            >
              {t(`normal.skill.${code}`)}
            </P1>
          </Flex>
          <P3
            color="var(--Neutral-dark-40)"
            style={{ fontSize: screens.md ? 12 : 10 }}
          >
            {t(`subtitle.skill.${code}`)}
          </P3>
        </Flex>
      );
    };

    if (skillCode) {
      _skill = skillCode.map((skill: string) => {
        return {
          label: renderSkillLabel(skill),
          value: skill,
        };
      });
    } else {
      if (!skillList) return;
      _skill = skillList.map((skill: SkillResponse) => {
        return {
          label: renderSkillLabel(skill.skill_code),
          value: skill.skill_code,
        };
      });
    }
    setSkillOptions(_skill);
  }, [skillCode, skillList, screens]);

  return (
    <>
      <Select
        value={
          form.getFieldValue("skill_type")
            ? form.getFieldValue("skill_type")
            : undefined
        }
        popupClassName="skill-selector-popup"
        placeholder={t("home.searchbar.skill.hint")}
        open={openDropdown}
        onClick={handleClick}
        onDropdownVisibleChange={handleDropdownVisibleChange}
        onChange={onSkillChange}
        options={skillOptions}
        dropdownRender={(menu) => {
          return (
            <>
              {menu}
              <P3 style={{ margin: "4px 0 4px 15px" }} color="var(--info)">
                {t("age.skill.recomendation")}
              </P3>
            </>
          );
        }}
        prefix={
          screens.lg ? null : (
            <SkiOutlined
              style={{
                fontSize: 24,
                color: "var(--Neutral-dark-80)",
              }}
            />
          )
        }
        suffixIcon={
          screens.lg ? (
            <SkiOutlined
              style={{
                fontSize: 24,
                color: "var(--Neutral-dark-80)",
              }}
            />
          ) : null
        }
      />
      <CenterPopup
        getContainer={() =>
          document.getElementById("containerElement") || document.body
        }
        onClose={() => setOpenPopup(false)}
        closeOnMaskClick={true}
        visible={openPopup}
        style={{ zIndex: 10000 }}
      >
        {renderSkillDropdownContent()}
      </CenterPopup>
    </>
  );
};

export default SkillSelector;
